<template>
  <div
    class="tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-3 tw-rounded-md tw-border-2 tw-p-3 tw-border-danger-500 tw-bg-danger-100"
    role="alert"
    data-test-id="user-not-connected-to-m365-warning-banner"
  >
    <div class="tw-bg-danger-200 tw-p-1 tw-rounded-full tw-text-danger-500">
      <cl-icon-tabler-alert-triangle
        data-test-id="user-not-connected-to-m365-warning-banner"
      />
    </div>
    <div class="tw-flex-grow tw-whitespace-normal tw-break-words">
      <div
        class="tw-text-lg tw-font-semibold"
        data-test-id="user-not-connected-to-m365-warning-banner"
      >
        {{ t("banner-title-account-not-protected") }}
      </div>
      <div data-test-id="user-not-connected-to-m365-warning-banner">
        {{ t("banner-text-connect-m365-account") }}
      </div>
    </div>
    <div class="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center">
      <cl-button
        :variant="'secondary'"
        type="button"
        :data-test-id="`user-not-connected-to-m365-warning-banner-add-connection-button`"
        @on-click="onAddConnectionClick"
      >
        {{ t("button-add-connection") }}
      </cl-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { router } from "@/router";

const { t } = useI18n();
const store = useStore();

const getMailFlow = computed(() => store.getters["history/getMailFlow"]);

const onAddConnectionClick = () => {
  router.push({ name: "customer-settings-connections" });
};

watch(
  getMailFlow,
  (newVal) => {
    return newVal;
  },
  { deep: true },
);
</script>
